// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ax-segments {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: var(--ax-padding);
}
.ax-segments button {
  background: none;
  font-size: 30px;
  padding: 0;
  color: var(--ion-text-color);
}
.ax-segments button.active {
  font-weight: bold;
  border-bottom: 3px solid var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-segments/ax-segments.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;AACF;AACE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,4BAAA;AACJ;AACI;EACE,iBAAA;EACA,iDAAA;AACN","sourcesContent":[".ax-segments {\n  display: flex;\n  justify-content: space-around;\n  align-items: flex-start;\n  padding: var(--ax-padding);\n\n  button {\n    background: none;\n    font-size: 30px;\n    padding: 0;\n    color: var(--ion-text-color);\n\n    &.active {\n      font-weight: bold;\n      border-bottom: 3px solid var(--ion-color-primary);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
